import { render, staticRenderFns } from "./SkeletonCardBox.vue?vue&type=template&id=08593345&scoped=true&"
import script from "./SkeletonCardBox.vue?vue&type=script&lang=js&"
export * from "./SkeletonCardBox.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonCardBox.vue?vue&type=style&index=0&id=08593345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08593345",
  null
  
)

export default component.exports